import React, {FC} from "react";
import {
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useMedia} from "../../../../../newShared/hooks/useMedia";
import {TableRowSkeleton} from "../../../../../newShared/components/tableRowSkeleton";
// import {RemoveFrameworkDialog} from "../../components/dialogs/removeFrameworkDialog";
import {PageWrapper} from "../../../../../newShared/components/Layouts";
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {useEvidencesList} from "../../hooks/useEvidencesList";
import {DeleteEvidenceDialog} from "../../components/dialogs/evidences/deleteEvidenceDialog";
import {EditEvidenceDialog} from "../../components/dialogs/evidences/editEvidenceDialog";
import {AddCustomEvidenceDialog} from "../../components/dialogs/evidences/addCustomEvidence";
import {PageTitleAndActions} from "../../../../../newShared/components/pageTitleAndActions";
import colors from "../../../../../newShared/theme/colors";
import {TableCardSkeleton} from "../../../../../newShared/components/tableCardSkeleton";
import {GenericFiltersArray} from "../../../../../newShared/components/genericFilter";


export const EvidencesList: FC = () => {
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'builderPage'});
    const {isLessThen1050} = useMedia();

    const {
        evidences,
        isLoadingEvidence,

        handleOpenAddEvidenceDialog,
        handleOpenEditEvidence,
        handleOpenDeleteEvidence,
        currentSearchForFetch
    } = useEvidencesList();

    // const {handleThreeDotsOpen, handleThreeDotsClose, anchorThreeDotsEl} = useThreeDotsMenu();

    // const {filter} = useParameters();
    //
    // //Pagination and filtering
    // const {value: searchValue, handleChange} = useSearchFieldURL({wait: 0});
    // const {setFilter, handleKeyDown} = useFilterUrl({
    //     getData: (filters) => {}
    // });

    return (
        <PageWrapper>

            <PageTitleAndActions
                title={t('Created evidences')}
                actions={[
                    {
                        title: t('Create evidence'),
                        onClick: () => handleOpenAddEvidenceDialog(null),
                        variant: 'text',
                        icon: <LibraryAddOutlinedIcon style={{marginLeft: revDir ? '9px' : undefined}}/>,
                    }
                ]}
            />

            <GenericFiltersArray
                configs={[]}
                fetchResultWithSelectedFilters={() => null}
                isAddFilters={false}
            />
            {/*<Breadcrumbs/>*/}
            {/*<Box display={"flex"} alignItems={"center"} marginTop={'12px'}>*/}
            {/*    <Typography variant={!matches_1440Down ? "h1" : 'h3'} margin={!revDir ? '0 32px 0 8px' : '0 8px 0 32px'}>{t('Created evidences')}</Typography>*/}
            {/*    <Button sx={{margin: '0 8px'}} variant={"text"} startIcon={<LibraryAddOutlinedIcon style={{marginLeft: revDir ? '9px' : undefined}}/>} size={matches_1440Down ? 'medium' : undefined}*/}
            {/*            onClick={() => handleOpenAddEvidenceDialog(null)}>*/}
            {/*        {t('Create evidence')}*/}
            {/*    </Button>*/}
            {/*</Box>*/}

            {/*<SearchField onClear={() => {setFilter('input'); handleChange({target: {value: ''}})}}*/}
            {/*             value={searchValue} onKeyDown={handleKeyDown} onChange={handleChange} disabled={isLoadingEvidence || isLoading}*/}
            {/*             sx={{mt: '16px', mb: isLessThen1050 ? '16px' : undefined, maxWidth: !isMobile ? '320px' : undefined}}/>*/}

            <TableContainer>
                <Table stickyHeader>
                    {isLessThen1050 ?
                        <TableBody>
                            { evidences
                                .filter(e => e?.name.trim().toLowerCase().includes(currentSearchForFetch.trim().toLowerCase()))
                                .map((ev) => ev && (
                                    <TableRow key={ev.id} >
                                        <TableCell style={{ padding: 0, borderBottom: 'none' }}>
                                            <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'} sx={{borderRadius: '8px', m: '6px', p: '8px', boxShadow: '0px 8px 16px rgba(125, 151, 174, 0.08), 0px 2px 6px rgba(125, 151, 174, 0.02), 0px 0px 1px rgba(125, 151, 174, 0.02)'}}>
                                                <Box display={'flex'} >
                                                    <Typography variant={'body2'} sx={{color: colors.lightGrayText, whiteSpace: 'nowrap'}}>{t('Name')}</Typography>
                                                    <Typography variant={'body2'} sx={{color: colors.darkText, ml: '6px', mr: '6px'}}>{ev?.name || ''}</Typography>
                                                </Box>
                                                <Box display={'flex'} >
                                                    <Typography variant={'body2'} sx={{color: colors.lightGrayText, whiteSpace: 'nowrap'}}>{t('Evidence type')}</Typography>
                                                    <Typography variant={'body2'} sx={{color: colors.darkText, ml: '6px', mr: '6px'}}>{'Private'}</Typography>
                                                </Box>
                                                <Box display={'flex'} >
                                                    <Typography variant={'body2'} sx={{color: colors.lightGrayText, whiteSpace: 'nowrap'}}>{t('Attached controls')}</Typography>
                                                    <Typography variant={'body2'} sx={{color: colors.darkText, ml: '6px', mr: '6px'}}>{ev.foundInControlsCounter}</Typography>
                                                </Box>
                                                <Box display={"flex"} alignSelf={"flex-end"}>
                                                    <Button size={'small'} variant={'text'} startIcon={<EditIcon/>} sx={{textTransform: 'none', ml: '6px', mr: '6px'}} onClick={() => ev?.id && handleOpenEditEvidence(ev.id, ev)} >{t('Edit')}</Button>
                                                    <Button size={'small'} variant={'text'} startIcon={<DeleteForeverIcon/>} sx={{textTransform: 'none'}} onClick={() => ev?.id && handleOpenDeleteEvidence(ev.id)} >{t('Delete')}</Button>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                            {isLoadingEvidence && <TableCardSkeleton />}
                        </TableBody>
                        :
                        <>
                            <TableHead>
                                <TableRow>
                                    <TableCell align={revDir ? "right" : 'left'}>{t('Name')}</TableCell>
                                    <TableCell align={revDir ? "right" : 'left'}>{t('Evidence type')}</TableCell>
                                    <TableCell align={revDir ? "right" : 'left'}>{t('Attached controls')}</TableCell>
                                    <TableCell/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {evidences
                                    .filter(e =>
                                        e?.name.trim().toLowerCase().includes(currentSearchForFetch.trim().toLowerCase())
                                    )
                                    .map((ev) => ev && (
                                        <TableRow key={ev.id} >
                                            <TableCell align={revDir ? "right" : 'left'}>{ev.name}</TableCell>
                                            <TableCell align={revDir ? "right" : 'left'}>{'Private'}</TableCell>
                                            <TableCell align={revDir ? "right" : 'left'}>{ev.foundInControlsCounter}</TableCell>
                                            <TableCell sx={{padding: '0'}}>
                                                <Box display={"flex"} alignItems={"center"}>
                                                    <IconButton size={"medium"} onClick={() => ev?.id && handleOpenEditEvidence(ev.id, ev)} >
                                                        <EditIcon/>
                                                    </IconButton>
                                                    <IconButton size={"medium"} onClick={() => ev?.id && handleOpenDeleteEvidence(ev.id)}>
                                                        <DeleteForeverIcon/>
                                                    </IconButton>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                {isLoadingEvidence && <TableRowSkeleton columns={4}/>}
                            </TableBody>
                        </>
                    }
                </Table>
            </TableContainer>


            <AddCustomEvidenceDialog/>
            <EditEvidenceDialog />
            <DeleteEvidenceDialog/>
        </PageWrapper>
    )
}